import { render, staticRenderFns } from "./left_whole.vue?vue&type=template&id=791e07a3&scoped=true&"
import script from "./left_whole.vue?vue&type=script&lang=js&"
export * from "./left_whole.vue?vue&type=script&lang=js&"
import style0 from "./left_whole.vue?vue&type=style&index=0&id=791e07a3&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791e07a3",
  null
  
)

export default component.exports